// removed by extract-text-webpack-plugin
module.exports = {"root":"_2aXDH","large":"_2WelV"};